<template>
  <div>
    <div class="row bg-cat" :style="'margin: 0; color:#fff; min-height:100vh; padding: 30px 0 50px 0;'">
      <div class="container bgw">
        <div class="row">
          <div class="col-md-12">
            <h1 class="text-center">Скидки и акции</h1>
          </div>

          <div class="col-md-12 text-left" v-for="sale in state.sales">
            <hr>
            <h2 class="text-center" v-if="sale.descr && sale.name ">{{ sale.name }}</h2>
            <img v-if="sale.image" style="width:100%;" :src="config.url + config.img_url + config.id + '/' + sale.image" :alt="sale.name">
            <p v-if="sale.descr ">{{ sale.descr }}</p>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      state() {
        return this.$store.state
      },
      config() {
        return this.$store.state.config
      }
    },
    methods: {
      bg() {
        var vm = this;
        return vm.state.config.url + vm.state.config.img_url + vm.state.config.id + '/' + vm.state.info.background;
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Sales/Sale.vue